import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  readAreaUnitParam,
  readAreaParam,
  readUserSeatsParam,
  readPlanetImageryParam,
} from '../../../../shared/helpers/functions/navigation';
import rootStore from '../../rootStore/RootStore';
import { AreaUnit } from '../../../../shared/graphql/graphql';

/**
 * Hook that reads search parameters from the URL and updates uiStateStore accordingly.
 */
export default function useSaveSearchParams() {
  const [searchParams] = useSearchParams();
  const areaUnit = readAreaUnitParam(searchParams);
  const area = readAreaParam(searchParams);
  const userSeats = readUserSeatsParam(searchParams);
  const planetImagery = readPlanetImageryParam(searchParams);

  const { uiStateStore, areaUnitStore } = rootStore;

  useEffect(() => {
    if (areaUnit != null) {
      areaUnitStore.setAreaUnit(areaUnit as AreaUnit);
    }

    if (area != null) {
      uiStateStore.setAnnualPlanArea(area);
    }

    if (userSeats != null) {
      uiStateStore.setAnnualPlanSeats(userSeats);
    }

    if (planetImagery != null) {
      uiStateStore.setAnnualPlanPlanetImagery(planetImagery);
    }
  }, [areaUnit, area, userSeats, planetImagery, uiStateStore, areaUnitStore]);
}
